import { lazy } from "react";
import { BASE_PATH } from "context/SiteSettingsContext/utils";
import { ERouteMappingKeys } from "./routeKeys";

export const partnerHubRoutes = {
  [ERouteMappingKeys.PARTNER_HUB]: {
    id: "partner-hub",
    path: "/partner-hub",
    components: {
      [BASE_PATH]: lazy(() =>
        import("pages/Sections/UniFiPartnerHub/UniFiPartnerHub").then((p) => ({
          default: p.UniFiPartnerHub,
        })),
      ),
      "partner-program": lazy(() =>
        import("pages/Sections/UniFiPartnerHub/UniFiPartnerHub").then((p) => ({
          default: p.UniFiPartnerHub,
        })),
      ),
    },
  },
};
